<div id="media" class="my-5">
    <div class="container-fluid px-2 px-lg-5">
        <div class="row mb-5">
            <div class="col-12 text-center" data-scroll>
                <h2 class="section-title"><span class="highlight">Press & Media</span></h2>
                <!-- <p class="section-subtitle">Stay updated with the latest happenings and events at GNKC</p> -->
                <div class="title-underline"></div>
            </div>
        </div>
        <owl-carousel-o [options]="customOptions" class="documentation">
            <ng-container *ngFor="let item of media">
                <ng-template carouselSlide>
                    <div class="activity-card m-2">
                        <div class="card-image-wrapper">
                            <img [src]="item.imgUrl" alt="Activity Image">
                            <div class="overlay"></div>
                            <div class="curve-shape">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                                    <path fill="#ffffff" fill-opacity="1"
                                        d="M0,224L48,213.3C96,203,192,181,288,181.3C384,181,480,203,576,224C672,245,768,267,864,261.3C960,256,1056,224,1152,197.3C1248,171,1344,149,1392,138.7L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z">
                                    </path>
                                </svg>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="badge-date">Recent</div>
                            <h4 class="activity-title" title="{{item.caption}}">{{item.caption}}</h4>
                            <a routerLink="/media" class="read-more-btn">
                                View Details <i class="fas fa-arrow-right"></i>
                            </a>
                        </div>
                    </div>
                </ng-template>
            </ng-container>
        </owl-carousel-o>
    </div>
</div>